/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PageSignallerDTO } from '../models/PageSignallerDTO';
import type { ProfileOutputDTO } from '../models/ProfileOutputDTO';
import type { SignallerDTO } from '../models/SignallerDTO';
import type { SignallerExtendedDTO } from '../models/SignallerExtendedDTO';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CustomSignallerResourceService {
    /**
     * Complete or update Signaller profile
     * Update a Signaller profile after verifying the user's email
     * @returns SignallerExtendedDTO OK
     * @throws ApiError
     */
    public static updateSignallerProfile({
        signallerId,
        requestBody,
    }: {
        /**
         * The id of the signaller logged
         */
        signallerId: number,
        requestBody: SignallerExtendedDTO,
    }): CancelablePromise<SignallerExtendedDTO> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/custom/signaller/completeProfile/{signallerId}',
            path: {
                'signallerId': signallerId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get the signaller dto requested
     * Retrieves the signaller dto requested
     * @returns SignallerDTO OK
     * @throws ApiError
     */
    public static getSignaller1({
        signallerId,
    }: {
        /**
         * The id of the signaller requested
         */
        signallerId: number,
    }): CancelablePromise<SignallerDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/custom/signaller/{signallerId}',
            path: {
                'signallerId': signallerId,
            },
        });
    }
    /**
     * Get a paginated list of users who need to be rewarded
     * Retrieves a paginated list of all WiBro signallers who need to be rewarded
     * @returns PageSignallerDTO OK
     * @throws ApiError
     */
    public static getAllSignallersToBeRewarded({
        page,
        size = 10,
        sortBy = 'dateCreate',
        sortDir = 'asc',
    }: {
        /**
         * The page number for pagination
         */
        page?: number,
        /**
         * The number of items page for pagination
         */
        size?: number,
        /**
         * The field to sort the results by
         */
        sortBy?: string,
        /**
         * The sorting direction
         */
        sortDir?: string,
    }): CancelablePromise<PageSignallerDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/custom/signaller/signallersToBeRewarded',
            query: {
                'page': page,
                'size': size,
                'sortBy': sortBy,
                'sortDir': sortDir,
            },
        });
    }
    /**
     * Get a paginated list of users who need to be paid
     * Retrieves a paginated list of all WiBro signallers who need to be paid
     * @returns PageSignallerDTO OK
     * @throws ApiError
     */
    public static getAllSignallersToBePaid({
        page,
        size = 10,
        sortBy = 'dateCreate',
        sortDir = 'asc',
    }: {
        /**
         * The page number for pagination
         */
        page?: number,
        /**
         * The number of items page for pagination
         */
        size?: number,
        /**
         * The field to sort the results by
         */
        sortBy?: string,
        /**
         * The sorting direction
         */
        sortDir?: string,
    }): CancelablePromise<PageSignallerDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/custom/signaller/signallersToBePaid',
            query: {
                'page': page,
                'size': size,
                'sortBy': sortBy,
                'sortDir': sortDir,
            },
        });
    }
    /**
     * Retrieves current User profile
     * Returns information's about the current logged user
     * @returns ProfileOutputDTO OK
     * @throws ApiError
     */
    public static getUserProfile(): CancelablePromise<ProfileOutputDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/custom/signaller/profile',
        });
    }
    /**
     * Get the signallerExtended dto requested
     * Retrieves all signaller and user info requested
     * @returns SignallerExtendedDTO OK
     * @throws ApiError
     */
    public static getSignallerExtended({
        signallerId,
    }: {
        /**
         * The id of the signaller requested
         */
        signallerId: number,
    }): CancelablePromise<SignallerExtendedDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/custom/signaller/completedProfile/{signallerId}',
            path: {
                'signallerId': signallerId,
            },
        });
    }
    /**
     * Get a paginated list of all WiBro users
     * Retrieves a paginated list of all WiBro signallers
     * @returns PageSignallerDTO OK
     * @throws ApiError
     */
    public static getAllSignallers1({
        page,
        size = 10,
        sortBy = 'dateCreate',
        sortDir = 'asc',
    }: {
        /**
         * The page number for pagination
         */
        page?: number,
        /**
         * The number of items page for pagination
         */
        size?: number,
        /**
         * The field to sort the results by
         */
        sortBy?: string,
        /**
         * The sorting direction
         */
        sortDir?: string,
    }): CancelablePromise<PageSignallerDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/custom/signaller/allSignallers',
            query: {
                'page': page,
                'size': size,
                'sortBy': sortBy,
                'sortDir': sortDir,
            },
        });
    }
    /**
     * Delete user logged account
     * Delete all information of Signaller logged on WiBro
     * @returns any OK
     * @throws ApiError
     */
    public static deleteMyAccount({
        signallerId,
    }: {
        /**
         * The id of the signaller to delete
         */
        signallerId: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/custom/signaller/deleteMyAccount/{signallerId}',
            path: {
                'signallerId': signallerId,
            },
        });
    }
}
